/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.service('ConfigService', ["$rootScope", "$http", function ($rootScope, $http) {

        var myConfig = {}
        
       
       var resetAll = function()
       {
           
       }
       
       var set = function(ind, data)
       {
           var prefixedInd = "atlas_config_"+ind
           var config = localStorage.setItem(prefixedInd, data)
       }
       var get = function(ind)
       {
           var prefixedInd = "atlas_config_"+ind
           var config = localStorage.getItem(prefixedInd)
           return config;           
       }

        return {
            get: get,
            set: set
        };

    }]);